import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from '@/domain/vuex/store'
import '@/support/plugin/axios'

//Plugins
import vuetify from '@/support/plugin/vuetify'
import VueTheMask from 'vue-the-mask'
import Vuelidate from 'vuelidate'
import VAnimateCss from 'v-animate-css';
import * as VueGoogleMaps from 'vue2-google-maps'
import Toasted from 'vue-toasted';
import VueClipboard from 'vue-clipboard2'

//Filters
import { filters } from "@/support/filters/filters"
 
Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyDmlWg5i9_t8wyp-fwLv0rvZvTGD72FD4Q',
    },
  }
)
Vue.use(Toasted, {
    duration: 2500,
    keepOnHover: true,
    closeOnSwipe: true,
    fitToScreen: true,
    singleton: false,
    theme: 'bubble',
    className: 'toast',
    action : {
      onClick : (e, toastObject) => {
        toastObject.goAway(0);
      }
    }
  }
)
Vue.use(VueTheMask)
Vue.use(Vuelidate)
Vue.use(VAnimateCss)
Vue.use(VueClipboard)

VueClipboard.config.autoSetContainer = true 
Vue.config.productionTip = false

filters.forEach( filter => {
    Vue.filter(filter.name, filter.execute);
  }
);

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
